import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'service-pricing-limits',
  templateUrl: './service-pricing-limits.component.html',
  styleUrls: ['./service-pricing-limits.component.scss']
})
export class ServicePricingLimitsComponent implements OnInit {
  serviceAdd = false;
  loading: boolean;
  serviceList: any;
  subServiceList: any;
  customerKey: string;
  service: any;
  subService: any;
  priceLimit: any;
  servicePriceLimit: any;
  currentRecordKey: any;
  editService: any;
  editSubService: any;
  editLimit: any;
  postData: any;
  useLimit: any;
  constructor(public dialogRef: MatDialogRef<ServicePricingLimitsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpClient
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    let limit = sessionStorage.getItem("useLimit");
    this.useLimit = (limit == "1") ? true : false;
    this.customerKey = sessionStorage.getItem('legacyCustomerKeyId');
    this.getServicePriceLimit();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  servicePricingAdd() {
    this.getServiceList();
    this.serviceAdd = true;
  }

  getServiceList() {
    this.loading = true;
    this.http.get(environment.baseUrl + `api/vendorSearch/GetVendorServiceSearch`)
      .subscribe((response: any) => {
        this.serviceList = response.body;
        this.loading = false;
      });
  }

  getSubServices(serviceKey) {
    this.loading = true;
    this.http.get(environment.baseUrl + `api/vendorSearch/GetVendorSubServiceSearch/${serviceKey}`)
      .subscribe((response: any) => {
        this.subServiceList = response.body;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('ServicePricingLimitsComponent_getSubServices', error);
      });
  }

  addServicePriceLimit() {
    this.loading = true;
    if (this.currentRecordKey > 0) {
      this.postData = {
        "customerKey": 0,
        "serviceKey": this.editService,
        "subServiceKey": this.editSubService,
        "priceLimit": this.editLimit,
        "limitRecordKey": this.currentRecordKey
      }
    } else {
      this.postData = {
        "customerKey": this.customerKey,
        "serviceKey": this.service,
        "subServiceKey": this.subService,
        "priceLimit": this.priceLimit,
        "limitRecordKey": 0
      }

    }
    this.http.post(environment.baseUrl + `addServicePriceLimit`, this.postData)
      .subscribe((response: any) => {
        this.serviceAdd = false;
        this.service = 0;
        this.subService = 0;
        this.priceLimit = '';
        this.currentRecordKey = 0;
        this.loading = false;
        this.getServicePriceLimit();
      }, (error) => {
        this.loading = false;
        console.error('ServicePricingLimitsComponent_addServicePriceLimit', error);
      });
  }

  getServicePriceLimit() {
    this.loading = true;
    this.http.get(environment.baseUrl + `getServicePriceLimit/${this.customerKey}`)
      .subscribe((response: any) => {
        this.servicePriceLimit = response.response;
        this.loading = false;
      }, (error) => {
        this.loading = false;
        console.error('ServicePricingLimitsComponent_getServicePriceLimit', error);
      });
  }

  editServicePriceLimit(servicePriceLimit) {
    this.getServiceList();
    this.getSubServices(servicePriceLimit.serviceKey);
    this.currentRecordKey = servicePriceLimit.limitRecordKey;
    this.editService = servicePriceLimit.serviceKey;
    this.editSubService = servicePriceLimit.subServiceKey;
    this.editLimit = servicePriceLimit.priceLimit;
  }

  deleteServicePriceLimit(recordKey) {
    this.loading = true;
    this.http.get(environment.baseUrl + `deleteServicePriceLimit/${recordKey}`)
      .subscribe((response: any) => {
        this.loading = false;
        this.getServicePriceLimit();
      }, (error) => {
        this.loading = false;
        console.error('ServicePricingLimitsComponent_deleteServicePriceLimit', error);
      });
  }

  cancel() {
    this.currentRecordKey = 0;
  }
  
  updateServicePriceUseLimit() {
    this.useLimit = this.useLimit == true ? 1 : 0;
    let data = {
      "customerKey": this.customerKey,
      "servicePriceUseLimit": this.useLimit
    }
    this.http.post(environment.baseUrl + `updateServicePriceUseLimit`, data)
      .subscribe((response: any) => {
        sessionStorage.setItem("useLimit", this.useLimit);
      }, (error) => {
        this.loading = false;
        console.error('ServicePricingLimitsComponent_updateServicePriceUseLimit', error);
      });
  }
  
}
